import config from '../config';
import { isServer } from './helpers';

export function getGraphQLUrl() {
  return isServer()
    ? `${config.dockerServerUrl}/gql/`
    : `${config.publicServerUrl}/gql/`;
}

export function getPublicServerUrl() {
  return isServer() ? config.dockerServerUrl : config.publicServerUrl;
}

export function getBasePath(user) {
  return user && user.isAdmin ? 'admin' : 'cabinet';
}
